var _circle, _line, _rect, _line2, _line3, _rect2, _line4, _line5, _rect3, _line6, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0f3460"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 18,
    stroke: "#a8d8f0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18,
    width: 5,
    height: 7,
    rx: 1,
    fill: "#a8d8f0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 25,
    x2: 9,
    y2: 28,
    stroke: "#a8d8f0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 11,
    x2: 20,
    y2: 14,
    stroke: "#61dafb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 14,
    width: 5,
    height: 9,
    rx: 1,
    fill: "#61dafb"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 23,
    x2: 20,
    y2: 26,
    stroke: "#61dafb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 8,
    x2: 31,
    y2: 11,
    stroke: "#61dafb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 11,
    width: 5,
    height: 11,
    rx: 1,
    fill: "#61dafb"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 22,
    x2: 31,
    y2: 25,
    stroke: "#61dafb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9,15 20,11 31,8",
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeDasharray: "2,2",
    opacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e0a9d67ea0deb3c02635a56bbb1a4c10.svg";
export { ForwardRef as ReactComponent };